import {useEffect, useState} from "react";
import {AuthService} from "../../services/Auth.service";
import {Card, Descriptions, Divider, Tabs, Typography} from "antd";
import {FilePdfOutlined} from "@ant-design/icons";

interface UserProfile {
    id: number;
    email: string;
    nome: string;
    cognome: string;
    ruolo: {
        id: number;
        nome: string;
        descrizione: string;
    };
}

const mockDocuments = [
    {
        id: 1,
        title: "Manuale utente",
        description: "Guida all'utilizzo della piattaforma",
        url: process.env.PUBLIC_URL+"/docs/ATS - Ticket Sanitari - Manuale_V1.3.pdf",
        button:"Apri documento PDF"
    },
    {
        id: 2,
        title: "Manuale amministratore",
        description: "Guida per l'amministratore",
        url: process.env.PUBLIC_URL+"/docs/MANUALE DI AMMINISTRAZIONE DI SISTEMA - Ticket.pdf",
        button:"Apri documento PDF"
    },
    {
        id: 3,
        title: "Modelli",
        description: "Modelli Word utilizzati dall'applicativo per generare i documenti",
        url: process.env.PUBLIC_URL+"/docs/moduli.zip",
        button:"Scarica archivio ZIP"
    }
];


const { Title, Text } = Typography;

export default function Profile() {

    const [userProfile, setUserProfile] = useState<UserProfile>()

    useEffect(() => {
        const fetchUsername = async () => {
            const data = await AuthService.getUsername();
            setUserProfile(data)
        };
        fetchUsername();
    }, []);


    return (

        <>
            <Title level={3}>Dati utente</Title>
            {userProfile &&
                <Card>
                    <Descriptions
                        column={1}
                        bordered
                        size="middle"
                    >
                        <Descriptions.Item label="Nome">
                            {userProfile.nome}
                        </Descriptions.Item>

                        <Descriptions.Item label="Cognome">
                            {userProfile.cognome}
                        </Descriptions.Item>

                        <Descriptions.Item label="Email">
                            <Text>{userProfile.email}</Text>
                        </Descriptions.Item>

                        <Descriptions.Item label="Ruolo">
                            <Text>{userProfile.ruolo.descrizione}</Text>
                        </Descriptions.Item>
                    </Descriptions>
                </Card>
            }
            <Divider></Divider>
            <Title level={3}>Documentazione</Title>
            <Card style={{ marginTop: 24 }}>
                <Tabs
                    items={mockDocuments.map(doc => ({
                        key: doc.id.toString(),
                        label: (
                            <span>
                            <FilePdfOutlined style={{ marginRight: 8 }} />
                                {doc.title}
                        </span>
                        ),
                        children: (
                            <div>
                                <Text type="secondary">
                                    {doc.description}
                                </Text>

                                <div style={{ marginTop: 16 }}>
                                    <a
                                        href={doc.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        {doc.button}

                                    </a>
                                </div>
                            </div>
                        ),
                    }))}
                />
            </Card>
        </>
    )
}
